module.exports = __webpack_public_path__ + "media/images/flags/ae-d2f94d449c3b6336bf091f52b5051c92.svg";